import { Controller } from "@hotwired/stimulus"

// Gives live feedback for the "Conversation" per-advocate period option, which
// is UI sugar for "once per conversation" (server normalizes it to a
// same-record limit of 1). When selected, the count is forced to 1, so we lock
// the count input. The server remains the source of truth — this is polish.
//
// Usage:
// <div data-controller="claim-limit-window">
//   <input data-claim-limit-window-target="count" ...>
//   <select data-claim-limit-window-target="window"
//           data-action="change->claim-limit-window#evaluate" ...>
// </div>
export default class extends Controller {
  static targets = ["count", "window"]

  connect() {
    this.evaluate()
  }

  evaluate() {
    if (!this.hasCountTarget || !this.hasWindowTarget) return

    if (this.windowTarget.value === "conversation") {
      this.countTarget.value = "1"
      this.countTarget.disabled = true
    } else {
      this.countTarget.disabled = false
    }
  }
}
